module.exports = __webpack_public_path__ + "img/issuesSolving.6e27c3c0.svg";